/**
 * Use this for inline styles with React
 * @example
 * const style: UprightStyle = {
  myClass: {display: 'block'}
}
 */
export interface UprightStyle {
  [className: string]: React.CSSProperties
}

/**
 * The Javascript Set type, which Typescript appears to be missing
 * @example
 * interface Props {
 *   aSetOfNumbers: Set<number>
 *   loading: boolean
 * }
 */
export interface Set<T> {
  add(value: T): this
  clear(): void
  delete(value: T): boolean
  forEach(callbackfn: (value: T, value2: T, set: Set<T>) => void, thisArg?: any): void
  has(value: T): boolean
  readonly size: number
}

/**
 * Type guard for checking if an error has a message property
 * @param e The error to check
 * @returns True if the error has a message property, false otherwise
 */
export function hasMessage(e: unknown): e is { message: string } {
  return typeof e === 'object' && e !== null && 'message' in e && typeof e.message === 'string'
}

/**
 * Type guard for checking if an error has an error property
 * @param e The error to check
 * @returns True if the error has an error property, false otherwise
 */
export function hasError(e: unknown): e is { error: string } {
  return typeof e === 'object' && e !== null && 'error' in e && typeof e.error === 'string'
}

/**
 * Type guard for checking if an error has an errors property, which is a record of string keys to arrays of strings
 * @param e The error to check
 * @returns True if the error has an errors property, false otherwise
 */
export function hasErrors(e: unknown): e is { errors: Record<string, string[]> } {
  return typeof e === 'object' && e !== null && 'errors' in e
}
